import React, { useState } from 'react'
import FloorPlanBangkok from '../Components/FloorPlanBangkok'
import FloorPlanImage from '../Components/FloorPlanImage'
import PageHelmet from '../Components/Pagehelmet'
import Breadcrumb from '../Components/Breadcrumb'

const TABS = [
  { key: 'interactive', label: 'Interactive Floor Plan' },
  { key: 'image', label: '2D Floorplan' },
]

const Floorplan = () => {
  const [activeTab, setActiveTab] = useState('interactive')

  return (
    <>
      <div>
        <PageHelmet pageTitle="Floorplan" />
        <Breadcrumb title="Floorplan" />

        <div className="d-flex justify-content-center pt-4 pb-2">
          <div
            style={{
              display: 'inline-flex',
              background: '#f1f3f5',
              borderRadius: '50px',
              padding: '5px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              border: '1px solid #e0e0e0',
              gap: '4px',
            }}
          >
            {TABS.map((tab) => {
              const isActive = activeTab === tab.key
              return (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  style={{
                    padding: '10px 28px',
                    borderRadius: '50px',
                    border: 'none',
                    cursor: 'pointer',
                    fontWeight: 600,
                    fontSize: '14px',
                    letterSpacing: '0.3px',
                    transition: 'all 0.25s ease',
                    background: isActive
                      ? 'linear-gradient(135deg, #ff2d95 0%, #e91e8c 100%)'
                      : 'transparent',
                    color: isActive ? '#fff' : '#555',
                    boxShadow: isActive
                      ? '0 2px 12px rgba(233,30,140,0.4)'
                      : 'none',
                  }}
                >
                  {tab.label}
                </button>
              )
            })}
          </div>
        </div>

        {activeTab === 'interactive' ? (
          <FloorPlanBangkok />
        ) : (
          <FloorPlanImage id="floorplan-image" />
        )}
      </div>
    </>
  )
}

export default Floorplan
